import api from "../Helper/api"

export const InsertPropertyInfo = (data?: any) =>{
    return  api().post("insert-property",data)
}

export const InsertMandetoryQue = (data?: any) =>{
    return  api().post("QnA",data)
}

export const InsertSubIntent = (data?: any) =>{
    return  api().post("submenu",data)
}

export const PublishConfig = (data?: any) =>{
    return  api().post("propertyKB",data)
}

export const AlternatePublishConfig = (propertyID) => {
    return api().post("generate-vectors", { property_id: propertyID });
}

export const getConfigByID = (data?: any) =>{
    return  api().post("get-property",data)
}

export const deleteQnA = (data?: any) =>{
    return  api().post("QNA-Delete",data)
}

export const InsertReservation = (data?: any) =>{
    return  api().post("reservation",data)
}
// export const oldchathistory = () =>{
//      return api().get(
//         `https://qna-api.chatobi.ai/get-customer-conversation`
//     );
// }
export const getChatHistory = (data?: any, propertyId?: any) => {
    // const queryParams = new URLSearchParams({
    //     connection_id: propertyId,
    // });

    return api().get(
        `chat-history`
    );
};
export const getNewChatHistory = (limit,last_key) => {
    const queryParams = new URLSearchParams({
        limit,
        last_key
    });

    return api().get(
        `getAllChats?${queryParams.toString()}`
    );
};
export const getIdentifiedChatHistory = (limit,last_key) => {
    const queryParams = new URLSearchParams({
        limit,
        last_key
    });

    return api().get(
        `getIdentifiedChats?${queryParams.toString()}`
    );
};
export const getAnonymousChatHistory = (limit,last_key) => {
    const queryParams = new URLSearchParams({
        limit,
        last_key
    });

    return api().get(
        `getAnonymousChats?${queryParams.toString()}`
    );
};
export const getInquiryChatHistory = (limit,last_key) => {
    const queryParams = new URLSearchParams({
        limit,
        last_key
    });

    return api().get(
        `getInquiryChats?${queryParams.toString()}`
    );
};
export const getCustomerChat = (conversation_id, thread_id) => {
    const params = new URLSearchParams({
        conversation_id,
        thread_id
    });

    return api().get(`get-conversation-detail?${params.toString()}`);
};

export const getQuestion = (data?: any) =>{
    return  api().post("Get-QNA",data)
}

export const getMenu = (data?: any) =>{
    return  api().post("get-menu",data)
}
export const deleteMenu = (data?: any)=>{
    return  api().post("menu-delete",data)
}

/** Saves the order of the key topics (1 = first). Sent to ``submenu`` so no new API Gateway path is needed. */
export const saveKeyTopicOrder = (data: { topics: { intentID: string; order: number }[] }) => {
    return api().post("submenu", { keyTopicOrder: data.topics })
}
export const getCompositeDataList=(data)=>{
    return  api().post("getCompositeData",data)
}
export const addcontactus = (data?: any)=>{
    return api().post("contact-us",data)
}

export const getCSBEProperty = ({ PropertyId, GroupId, ...rest }: any) => {
    return api().post("get-csbe-property", {
        ...(PropertyId && { PropertyId }),
        ...(GroupId && { GroupId }),
        ...rest
    });
};




export const saveMandetoryInfo = (data?: any)=>{
    return api().post("mandatory_info",data)
}


export const verifyToken = (data?: any)=>{
    return api().post("verification",data)
}
export const login = (data?: any)=>{
    return api().post("internalToken",data)
}
export const uploadDoc = (data?: any)=>{
    return api().post("doc-upload",data)
}
export const getDoc = (data?: any)=>{
    return api().post("display-doc",data)
}
export const downloadDoc = (data?: any)=>{
    return api().post("download-file",data)
}
export const deleteDoc = (data?: any)=>{
    return api().post("delete-doc",data)
}

export const filterChatHistory = (data?: any)=>{
    return api().post("filter-chathistory",data)
}
export const get_All_qna = (data?: any) =>{
    return api().post("get-QnA",data)
}
export const get_All_Intent = (data?: any) =>{
    return api().post("get-composite",data)
}

// UAT Session-based Chat History endpoints
// const UAT_BASE_URL = "https://kam64jpqt5.execute-api.us-east-1.amazonaws.com/v1";
// const UAT_BASE_URL = "https://qna-api.chatobi.ai";

export const getSessions = (limit = 10, lastKey = null) => {
    const params = new URLSearchParams({ limit: String(limit) });
    if (lastKey) {
        params.append("last_key", lastKey);
    }
    return api().get(`getSessions?${params.toString()}`);
};
 
export const getSessionCustomerChats = (session_id: any, customer_id?: any) => {
    const params = new URLSearchParams({ session_id });
    if (customer_id) {
        params.append("customer_id", customer_id);
    }
    return api().get(`getCustomerChats?${params.toString()}`);
};
 
// Review & Improve FAQs endpoint
export const reviewImproveFaqs = (data?: any) => {
    return api().post(`review-improve-faqs`, data);
};
 
// Analytics - Token Usage endpoints
export const getTokenUsageSummary = (from_date, to_date) => {
    const params = new URLSearchParams({ from_date, to_date });
    return api().get(`getTokenUsageSummary?${params.toString()}`);
};
 
export const getTokenUsageDetails = (date, limit = 500) => {
    const params = new URLSearchParams({ date: String(date), limit: String(limit) });
    return api().get(`getTokenUsageDetails?${params.toString()}`);
};
 
// Analytics - Performance endpoints
export const getPerformanceSummary = (from_date, to_date) => {
    const params = new URLSearchParams({ from_date, to_date });
    return api().get(`getPerformanceSummary?${params.toString()}`);
};
 
// Analytics - Booking Analytics endpoint
export const getBookingAnalytics = (from_date, to_date) => {
    const params = new URLSearchParams({ from_date, to_date });
    return api().get(`getBookingAnalytics?${params.toString()}`);
};

// Fetch a short-lived JWT for the chatbot admin preview
export const getAdminPreviewToken = (propertyId) => {
    return api().post("admin-preview-token", {
        property_id: propertyId,
        origin: window.location.origin
    });
};

// ElevenLabs Agent Setup endpoints
export const validateElevenLabsKey = (data?: any) => {
    return api().post("validate-agent-key", data);
};

export const getElevenLabsVoices = (data?: any) => {
    return api().post("agent/voices", data);
};

export const saveAgentConfig = (data?: any) => {
    return api().post("agent/save-config", data);
};

export const createAgent = (data?: any) => {
    return api().post("create-agent", data);
};

export const getAgentConfig = (propertyId) => {
    return api().get(`agent/get-config?property_id=${encodeURIComponent(propertyId)}`);
};

export const getAgent = () => {
    return api().get("get-agent");
};
